import { Injectable } from '@angular/core';
import { BaseRequestOptions, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';

@Injectable()
export class DefaultRequestOptions extends BaseRequestOptions {
  merge(options?: RequestOptionsArgs): RequestOptions {
    const newOptions = super.merge(options);
    if (!newOptions.headers) {
      newOptions.headers = new Headers();
    }
    newOptions.headers.set('Accept-Language', localStorage.getItem('lang') || 'vi');
    return newOptions;
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/DefaultRequestOptions.ts